<template>
  <div v-title="$route.meta.title"
       class="permission-group">
    <div class="page-heading">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item to="/">首页</el-breadcrumb-item>
        <el-breadcrumb-item>{{$route.meta.title}}</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <layout-panel>
      <span slot="header">权限组管理</span>
      <el-tabs v-model="activeName" type="card" @tab-click="handleClick">
        <el-tab-pane v-for="(platform, index) in platformlist" :key="index" :label="platform.name + '管理'" :name="platform.name">
          <el-container class="permission-group-panel"
                    :style="{ height: height + 'px' }">
        <div class="permission-group-left">
          <div class="permission-group-header">
            <b>权限组</b>
            <div class="permission-group-header-button">
              <el-button type="text"
                         icon="el-icon-plus"
                         @click="create()"></el-button>
            </div>
          </div>
          <el-scrollbar
            wrap-style="overflow-x: hidden;"
            :style="{ height: height - 48 + 'px' }">
            <ul class="permission-group-list">
              <draggable
                v-model="permissionGroupList"
                :options="{handle: '', disabled: false, scrollSensitivity: 60, scrollSpeed: 20}"
                @update="">
                <li v-for="(permissionGroup, index) in permissionGroupList"
                    :class="[activePermissionGroup===permissionGroup?'active':'']"
                    @click="onActivePermissionGroup(permissionGroup)">
                  <el-badge :value="permissionGroup.permission_ids.length">
                    {{permissionGroup.name}}
                  </el-badge>
                  <div class="permission-group-list-button">
                    <el-button type="text"
                               icon="el-icon-edit-outline"
                               @click="update(permissionGroup)"></el-button>
                    <el-button type="text"
                               icon="el-icon-delete"
                               @click="remove(permissionGroup.id, index)"></el-button>
                    <!--<el-button type="text" icon="sj-icon-move-vertical"></el-button>-->
                  </div>
                </li>
              </draggable>
            </ul>
          </el-scrollbar>
        </div>
        <div class="permission-group-right">
          <div class="permission-group-header">
            <b>权限分配</b>
            <small style="color: #606266"> 未分配 {{permissionUnselectedList.length}}</small>
          </div>
          <el-scrollbar
            wrap-style="overflow-x: hidden;"
            :style="{ height: height - 48 + 'px' }">
            <div class="permission-list">
              <!-- 已选择权限组的权限列表 -->
              <el-checkbox-group
                v-if="activePermissionGroup"
                v-model="activePermissionGroup.permission_ids">
                <draggable
                  v-model="activePermissionGroup.permission_ids"
                  :options="{handle: '', disabled: false, scrollSensitivity: 60, scrollSpeed: 20}"
                  @update="">
                  <el-checkbox
                    v-for="id in activePermissionGroup.permission_ids"
                    :key="permissionListMap[id].id"
                    :label="permissionListMap[id].id"
                    @change="(event) => onChangeSelectedPermissionList(event, id)"
                    border
                    size="medium">{{permissionListMap[id].name}}
                  </el-checkbox>
                </draggable>
              </el-checkbox-group>
              <!-- 未选择权限列表 -->
              <el-checkbox-group
                v-if="activePermissionGroup"
                v-model="activePermissionGroup.permission_ids">
                <el-checkbox
                  v-for="permission in permissionList"
                  v-show="!permission.selected"
                  :key="permission.id"
                  :label="permission.id"
                  @change="(event) => onChangeSelectedPermissionList(event, permission.id)"
                  border
                  size="medium">{{permission.name}}
                </el-checkbox>
              </el-checkbox-group>
            </div>
          </el-scrollbar>
        </div>
      </el-container>
        </el-tab-pane>
      </el-tabs>
      <div class="permission-group-footer">
        <el-button type="primary"
                   size="medium"
                   @click="onSave()">保 存
        </el-button>
      </div>
    </layout-panel>

    <permission-group-dialog :platformHost="currentPlatform.host" ref="permission-group-dialog"/>
  </div>
</template>

<script>
import draggable from 'vuedraggable'
import PermissionGroupDialog from '@/views/permission-group/pages/PermissionGroupDialog'

export default {
  components: {PermissionGroupDialog, draggable},
  data () {
    return {
      activePermissionGroup: null,
      permissionGroupList: [],
      permissionList: [],
      permissionListMap: {},
      permissionUnselectedList: [],

      activeName: '',
      platformlist: [],
      currentPlatform: {},
      activeIndex: 0,
    }
  },
  computed: {
    ...Vuex.mapState({
      clientHeight: state => state.clientHeight,
    }),
    height () {
      let height = this.clientHeight - 250
      if (height < 300) {
        height = 300
      }
      return height
    },
  },
  watch: {},
  created () {
    this.fetchPlatformlist().then(data => {
      this.netFetchData(data, 0)
    })
  },
  mounted () {},
  methods: {
    fetchPlatformlist () {
      return request.common('getPermissionPlatformlist', {}).then(({data}) => {
        this.activeName = data.main.name
        this.platformlist.push(data.main)
        this.platformlist.push(...data.others)
        return data.main
      })
    },
    handleClick (tab, event) {
      const platform = this.platformlist[tab.index]
      this.currentPlatform = platform
      if (!this.platformlist[tab.index].permissionList) {
        this.activeIndex = tab.index
        this.netFetchData(platform, tab.index)
      } else {
        this.updateActivePermission(this.activeIndex)
        this.activeIndex = tab.index
        this.permissionGroupList = [...this.platformlist[this.activeIndex].permissionGroupList]
        this.permissionList = [...this.platformlist[this.activeIndex].permissionList]
        this.permissionUnselectedList = [...this.platformlist[this.activeIndex].permissionUnselectedList]
        this.permissionListMap = {...this.platformlist[this.activeIndex].permissionListMap}
        // this.activePermissionGroup = {...this.platformlist[this.activeIndex].activePermissionGroup}
        this.activePermissionGroup = this.permissionGroupList[0]
      }
    },
    netFetchData (platform, activeIndex) {
      this.permissionGroupList = []
      this.permissionList = []
      this.permissionListMap = {}
      this.permissionUnselectedList = []
      request.all.common([
        request('getPermissionTable', {host: platform.host, per_page: 666}),
        request('getPermissionGroupTable', {host: platform.host}),
      ]).then(res => {
        // 权限列表
        this.permissionList = res[0].data.data
        this.permissionListMap = {}
        this.permissionList.forEach((permission) => {
          permission.selected = false
          this.permissionListMap[permission.id] = permission
        })
        // 权限组列表
        let permissionGroupList = res[1].data.data
        // 处理权限组列表
        permissionGroupList.forEach((group) => {
          group.permission_ids = []
          group.permissions.forEach(({id}) => {
            group.permission_ids.push(id)
            // 标记已选择
            this.permissionListMap[id].selected = true
          })
          delete group.permissions
        })
        // 获得未选择权限列表
        this.permissionList.forEach((permission) => {
          !permission.selected && this.permissionUnselectedList.push(permission.id)
        })
        this.permissionGroupList = permissionGroupList
        // 默认活跃权限组
        this.activePermissionGroup = permissionGroupList[0]
        this.updateActivePermission(activeIndex)
        this.platformlist[activeIndex].oldPermissionGroupList = JSON.parse(JSON.stringify(this.permissionGroupList))
      })
    },
    updateActivePermission (activeIndex) {
      this.platformlist[activeIndex].permissionGroupList = [...this.permissionGroupList]
      this.platformlist[activeIndex].permissionList = [...this.permissionList]
      this.platformlist[activeIndex].permissionUnselectedList = [...this.permissionUnselectedList]
      this.platformlist[activeIndex].permissionListMap = {...this.permissionListMap}
      // this.platformlist[activeIndex].activePermissionGroup = {...this.activePermissionGroup}
    },
    chekChangePermissionGroup ({permissionGroupList, oldPermissionGroupList}) {
      if (permissionGroupList.length !== oldPermissionGroupList.length) {
        return true
      }
      for (let index = 0; index < permissionGroupList.length; index++) {
        const permission = permissionGroupList[index]
        const oldPermission = oldPermissionGroupList[index]
        const ids = permission.permission_ids.sort((a, b) => a - b).join(',')
        const oldIds = oldPermission.permission_ids.sort((a, b) => a - b).join(',')
        if (ids !== oldIds) {
          return true
        }
      }
      return false
    },
    onSave () {
      this.updateActivePermission(this.activeIndex)
      const requests = this.platformlist.filter(platform => {
        if (platform.permissionGroupList && this.chekChangePermissionGroup(platform)) {
          return request('savePermissionGroupData', {host: platform.host, group_list: platform.permissionGroupList})
        }
      })
      request.all.common(requests).then(() => {
        this.$alert('权限组保存成功！', '提示', {type: 'success'})
      })
    },
    create () {
      this.$refs['permission-group-dialog'].create((group) => {
        group.permission_ids = []
        group.permissions.forEach(({id}) => {
          group.permission_ids.push(id)
        })
        this.permissionGroupList.push(group)
      })
    },
    update (group) {
      this.$refs['permission-group-dialog'].update((data) => {
        group.name = data.name
      }, group)
    },
    remove (id, index) {
      this.$confirm('此操作将永久删除该权限组, 是否继续?', '提示', {type: 'warning'}).then(() => {
        request.common('deletePermissionGroupData', {host: this.currentPlatform.host, id}).then(({data}) => {
          this.permissionGroupList.splice(index, 1)
          this.$message.success('删除权限组成功')
        })
      }).catch(() => {
        this.$message.info('已取消删除')
      })
    },
    onActivePermissionGroup (group) {
      this.activePermissionGroup = group
    },
    onChangeSelectedPermissionList (val, id) {
      this.permissionListMap[id].selected = val
      if (val) {
        this.permissionUnselectedList.splice(this.permissionUnselectedList.indexOf(id), 1)
      } else {
        this.permissionUnselectedList.push(id)
      }
    },
  },
}
</script>
<style lang="scss">
// 全局CSS
@import "../permission-group";
</style>
<style lang="scss"
       scoped>
// 带作用域的CSS
// https://vue-loader.vuejs.org/zh-cn/features/scoped-css.html
</style>
<style lang="scss"
       module>
// 带作用域的CSS
// 绑定class方式 <p :class="$style.red"></p>
// https://vue-loader.vuejs.org/zh-cn/features/css-modules.html
</style>



// WEBPACK FOOTER //
// src/views/permission-group/pages/PermissionGroupManage.vue